/**
 * Listens for search input keyup to add/remove clear button
 */
export const pageSearchKeyup = function () {
	const input = document.querySelector('[data-page-search="input"]');
  if (!input) return;

  const closeButton = document.querySelector('[data-page-search="clear"]');
  const submitButton = document.querySelector('[data-page-search="submit"]');


	input.addEventListener('keyup', () => {
    if(input.value != ''){
      closeButton.style.display = 'inline-block';
      submitButton.disabled = false;
    } else {
      closeButton.style.display = 'none';
      submitButton.disabled = true;
    }
  })
};

/**
 * Closes search input
 */
export const closePageSearch = function () {
  const input = document.querySelector('[data-page-search="input"]');
  const closeButton = document.querySelector('[data-page-search="clear"]');

  input.value='';
  closeButton.style.display = 'none';
  input.focus();
}

export const pageSearch = function () {
	pageSearchKeyup();
  window.Solver.closePageSearch = closePageSearch;
};
